var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8919_11421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9004 6.8125H13.6504V3.8125H3.15039C2.32539 3.8125 1.65039 4.4875 1.65039 5.3125V13.5625H3.15039C3.15039 14.8075 4.15539 15.8125 5.40039 15.8125C6.64539 15.8125 7.65039 14.8075 7.65039 13.5625H12.1504C12.1504 14.8075 13.1554 15.8125 14.4004 15.8125C15.6454 15.8125 16.6504 14.8075 16.6504 13.5625H18.1504V9.8125L15.9004 6.8125ZM5.40039 14.6875C4.77789 14.6875 4.27539 14.185 4.27539 13.5625C4.27539 12.94 4.77789 12.4375 5.40039 12.4375C6.02289 12.4375 6.52539 12.94 6.52539 13.5625C6.52539 14.185 6.02289 14.6875 5.40039 14.6875ZM15.5254 7.9375L16.9954 9.8125H13.6504V7.9375H15.5254ZM14.4004 14.6875C13.7779 14.6875 13.2754 14.185 13.2754 13.5625C13.2754 12.94 13.7779 12.4375 14.4004 12.4375C15.0229 12.4375 15.5254 12.94 15.5254 13.5625C15.5254 14.185 15.0229 14.6875 14.4004 14.6875Z",
    fill: "#23BA50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8919_11421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.900024 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.2a1f445543bfec5e6a8283e7d524f84e.svg";
export { ForwardRef as ReactComponent };